import { SyntheticEvent } from 'react';

import { TSvgProps } from '@r1-frontend/ui-react/components/svg/createSvg';
import { withRadius } from '@r1-frontend/ui-react/experimental/containers';

import { Label } from './styled';

export type TStepMenuItemProps = {
    isCurrent?: boolean,
    isLastActivated?: boolean,

    label: string,
    className?: string,

    onClick: (e: SyntheticEvent) => void,

    Icon?: (props: TSvgProps) => JSX.Element,
    Image?: string,
}

const StepMenuItem = ({ isCurrent, isLastActivated = false, label, Icon, Image, className, ...props }: TStepMenuItemProps): JSX.Element => {

    return (
        <li
            className={`${className}${isCurrent ? ' current' : ''}${isLastActivated ? ' last-activated' : ''}`}
            {...props}
        >
            {Image && <img src={Image} />}
            {Icon && <Icon />}

            <Label>{label}</Label>
        </li>
    );
};

export default withRadius<TStepMenuItemProps>(StepMenuItem, { $radius: 32 });
